import { FontFamily } from '@common/theming/Fonts';
import React, { ElementType } from 'react';

type TextWeight = 'bold' | 'normal' | 'thin';

const DEFAULT_FONTS: Record<TextWeight, string> = {
  bold: FontFamily.NEUE_HAAS_DISPLAY_BOLD,
  normal: FontFamily.NEUE_HAAS_DISPLAY_ROMAN,
  thin: FontFamily.NEUE_HAAS_DISPLAY_THIN,
};

const adjustTextForFont = (font: string, styles: React.CSSProperties) => {
  switch (font) {
    case FontFamily.NEUE_HAAS_DISPLAY_ROMAN:
    case FontFamily.NEUE_HAAS_DISPLAY_BOLD:
    case FontFamily.NEUE_HAAS_DISPLAY_THIN:
      return { ...styles, letterSpacing: '0.03rem', lineHeight: 1.5 };

    default:
      return styles;
  }
};

interface TextProps extends React.HTMLAttributes<HTMLDivElement> {
  weight?: 'bold' | 'normal' | 'thin';
  size?: number;
  fontFamily?: string;
  color?: string;
  as?: ElementType;
}

export const TextBlock: React.FC<TextProps> = (props) => {
  const { weight = 'normal', size = 12, color = 'white', as: Tag = 'div' } = props;

  const font = props.fontFamily || DEFAULT_FONTS[weight];

  let defaultStyles: React.CSSProperties = {
    color: color,
    fontFamily: font,
    fontSize: size,
  };

  defaultStyles = adjustTextForFont(font, defaultStyles);
  return <Tag {...props} style={{ ...defaultStyles, ...props.style }}></Tag>;
};
